import React from 'react';

import { EtatDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  etat: EtatDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  etat,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay label={LABEL_ID_CORRELATION} value={etat.idCorrelation} />
        <FieldDisplay label="Etat" value={etat.etat} />
        <FieldDisplay
          label="Détail"
          value={etat.detail}
          additionalValueClassName={'multiLineValue'}
        />
        <FieldDisplay label="Libellé court" value={etat.libelleCourt} />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
